import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";

/**
 * Wraps a layout/page and enforces authentication + optional role check.
 *
 * Usage:
 *   <ProtectedRoute allowedRoles={["SA","A"]}>
 *     <AdminLayout />
 *   </ProtectedRoute>
 */
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, role } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/auth/signin" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    // Redirect unauthorized roles to their default page
    return <Navigate to="/admin/default" replace />;
  }

  return children;
};

export default ProtectedRoute;
